import Operations from './operations';

export default Operations;
